/**
 * HighLowMa — High & Low do Silverlight.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLBands.cs, classe
 * FML.HighLow — FALSO-AMIGO do `highLow` HHV/LLV do odin, por isso a chave
 * nova):
 *
 *   H = MA(High, MHIGH)          L = MA(Low, MLOW)
 *   DESLOC_V ≠ 0 ⇒ H·(1+D/100) e L·(1−D/100)
 *
 * MA(f,N) é a média aritmética do engine (silverlightDsl.ma). Warm-up por
 * série: N−1 barras NaN (janelas podem ser assimétricas). Paridade provada em
 * __tests__/highLowMa.silverlight.test.js.
 */
import { ma, mul } from "./silverlightDsl";
import { HighLowMa as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { mHigh, mLow, deslocV } = options;

    const toNum = (v) => (Number.isFinite(v) ? v : NaN);
    let mh = ma(
      data.map((d) => toNum(d.high)),
      mHigh,
    );
    let ml = ma(
      data.map((d) => toNum(d.low)),
      mLow,
    );
    if (deslocV !== 0) {
      mh = mul(mh, 1 + deslocV / 100);
      ml = mul(ml, 1 - deslocV / 100);
    }

    // Borda com o chart: NaN vira undefined (por série; janelas assimétricas
    // deixam uma série viva antes da outra).
    return data.map((d, i) => {
      const high = Number.isFinite(mh[i]) ? mh[i] : undefined;
      const low = Number.isFinite(ml[i]) ? ml[i] : undefined;
      if (high === undefined && low === undefined) return undefined;
      return { high, low };
    });
  }

  calculator.undefinedLength = function () {
    const { mHigh, mLow } = options;
    return Math.max(0, Math.min(mHigh, mLow) - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
